import * as R from 'ramda'

export default function getCountryCode(key, countries) {
  const result = R.find(R.propEq('alpha2', key), countries)

  return result ? `+${result.countryCode}` : ''
}
